import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
import en from './locales/en.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    supportedLngs: ['de', 'en'],
    nsSeparator: ':',
    keySeparator: ':',
    interpolation: { escapeValue: false },
    resources: {
      de: { signup: de.signup },
      en: { signup: en.signup },
    },
    defaultNS: 'signup',
    ns: ['signup'],
  });

export default i18n;
